import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Row, Modal, Col, Form } from "react-bootstrap";
import SunEditor from "suneditor-react";
import plugins from "suneditor/src/plugins";
import { en } from "suneditor/src/lang";
import "suneditor/dist/css/suneditor.min.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Typography,
    TableBody,
    IconButton,
    Chip,
    Card,
    Stack,
    Tooltip,
    TextField,
    Pagination,
    TableContainer,
    Grid,
    Button,
    styled,
    TablePagination,
    Dialog,
    DialogTitle,
    DialogContent,
    CardActionArea,
    CardContent,
    DialogActions,
    Divider,
    Container,
    tooltipClasses,
} from '@mui/material';
import axios from "axios";
import moment from 'moment';
import { useTheme } from '@emotion/react';
import { IconCheck, IconCloudDown, IconEdit, IconEye, IconSquarePlus, IconX, IconXboxX } from '@tabler/icons-react';
import { BeatLoader } from 'react-spinners';
import PageContainer from './Pagecontainer';
import ScheduleDemo from './demo';
import Cookies from 'js-cookie';
const BoxStyled = styled(Box)(() => ({
    padding: '30px',
    transition: '0.1s ease-in',
    cursor: 'pointer',
    color: 'inherit',
    '&:hover': {
        transform: 'scale(1.03)',
    },
}));

const Support = () => {
    //   const customizer = useSelector((state) => state.customizer);
    const theme = useTheme();
    //   const borderColor = theme.palette.grey[100];

    const [activeButton, setActiveButton] = useState('');
    
    const navigate = useNavigate()
    const [tickets, settickets] = useState([])
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const [DetailShow, setDetailShow] = useState(false);
    const [editId, setEditId] = useState(null);
    const [idsticketno, setidsticketno] = useState(null);
    const [idsticketsub, setidsticketsub] = useState(null);
    const [idsticketpri, setidsticketpri] = useState(null);
    const [logoImagePathCon, setLogoImagePathCon] = useState(true);
    const { setValue, getValues, trigger, formState: { errors }, control, setError, clearErrors, reset } = useForm({ mode: "all" });
    const [opendataticket, setopendataticket] = useState([]);
    const [selectedTicketDetails, setSelectedTicketDetails] = useState(null);
    const [commetscustmer, setcommetscustmer] = useState([]);
    const [formValues3, setFormValues3] = useState([{}]);
    const { register, handleSubmit } = useForm({ mode: "all" });
    const [error, seterror] = useState("")
    const [error1, seterror1] = useState("")
    const [error2, seterror2] = useState("")
    const [disable, setDisable] = useState(false);
    const [imgErrorMsgPopUp, setImgErrorMsgPopUp] = useState(false);
    const [imgErrorMsgPopUpText, setImgErrorMsgPopUpText] = useState('');
    const [HaveImage, setHaveImage] = useState(false);
    const [PoliciesfilesErrorMessage, setPoliciesfilesErrorMessage] = useState();
    const [errmsgcommit, seterrmsgcommit] = useState();
    const [imageName, setImageName] = useState('');
    const [file, setFile] = useState(null);
    const [documents, setDocuments] = useState([]);
    const [selectedFileNames, setSelectedFileNames] = useState(["No file chosen"]);
    const [fileObjects, setFileObjects] = useState([null, null, null, null]);
    const [showModal, setShowModal] = useState(false);

    const options = {
        plugins: plugins,
        height: 250,
        // katex: katex,
        lang: en,
        buttonList: [
            [
                "font",
                "fontSize",
                "formatBlock",
                "bold",
                "underline",
                "italic",
                "paragraphStyle",
                "blockquote",
                "strike",
                "subscript",
                "superscript",
                "fontColor",
                "hiliteColor",
                "textStyle",
                "removeFormat",
                "undo",
                "redo",
                "outdent",
                "indent",
                "align",
                "horizontalRule",
                "list",
                "lineHeight",
                "table",
                "link",
                "image",
                "video",
                "audio",
                "fullScreen",
                "showBlocks",
                "codeView",
                "preview",
                "print",
            ],
        ],
    };

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [Count, setCount] = useState(0);
    const [status, setStatus] = useState('');
    const getUsersdatefilter = async (current = currentPage, Page = rowsPerPage, status = '', keyword = '') => {
        setLoader(false);
        // const userinfo = JSON.parse(Cookies.get("user-info"));
        const userinfo = JSON.parse(Cookies.get('user-info'));
        let url = `${process.env.REACT_APP_API_URL2}/apiV1/tickets_list/`;
        console.log(current);
        if (keyword) {
            const queryParams = new URLSearchParams({ keyword }).toString();
            url += `?${queryParams}`;
        }
        const req = {
            line_type: status,
            page_number: current,
            page_size: Page,
            user_email: userinfo.email,
            company_name: userinfo.name,
            roles: userinfo.user_type,
            username: userinfo.username,
            id: userinfo.id
        };

        try {
            // axios.defaults.headers.common = { 'Authorization': `` };
            const response = await axios.post(url, req,
                {
                    headers: {
                        Authorization: '',
                    }
                }
            );

            console.log("Response data:", response.data);

            if (response.data && response.data.results && response.data.results.data) {
                let results = response.data.results.data;
                settickets(results);
                setCount(response.data.results.pagination.total_items);
                setLoader(true);
            } else {
                console.error("Invalid response structure:", response.data);
            }
        } catch (error) {
            console.error("Error fetching tickets:", error);
            setLoader(true);
        }
    };

    // useEffect(() => {
    //   getUsersdatefilter(currentPage, 10, 'open')
    // }, []);


    const emptyRows = currentPage > 0 ? Math.max(0, (1 + currentPage) * perPage - tickets.length) : 0;
    const [totaltickets, settotaltickets] = useState(0)
    const [pendingC, setpendingC] = useState(0)
    const [openC, setopenC] = useState(0)
    const [closeC, setcloseC] = useState(0)
    const [loading, setLoading] = useState(false)

    const [originalStatus, setOriginalStatus] = useState("");

    const openTicketDetailsModal = async (data) => {
        setShow(true);
        setEditId(data.id);
        setidsticketno(data.ticket_number);
        setidsticketsub(data.ticket_sub_category_id);
        setidsticketpri(data.ticket_category_id);
        setOriginalStatus(data.ticket_status_value); // Store original status
        await onloadvalues(data);
        setLogoImagePathCon(true);
    };
    const TicketDetailsModal = async (data) => {
        setDetailShow(true);
        setEditId(data.id);
        setidsticketno(data.ticket_number);
        setidsticketsub(data.ticket_sub_category_id);
        setidsticketpri(data.ticket_category_id);
        setOriginalStatus(data.ticket_status_value); // Store original status
        await onloadvalues(data);
        setLogoImagePathCon(true);
    };
    const onloadvalues = async (data) => {
        // axios.defaults.headers.common = { 'Authorization': ` ` };
        setLoading(true)
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL2}/apiV1/ticket_details/${data.ticket_number}/`,
                {},
                {
                    headers: {
                        Authorization: '',
                    }
                }
            );

            console.log("Response object:", response);

            if (response.data.results.data) {
                const results = response.data.results.data[0];
                const resultss = response.data.results.data_doc;

                setopendataticket(results);
                setidsticketno(results.ticket_number);
                setSelectedTicketDetails(results);
                setcommetscustmer(response.data.results.data_reply);
                let newArray2 = [];

                resultss.map((file, i) => {
                    let temp = {
                        id: i,
                        attachment1: file,
                        is_deleted: false,
                    }
                    newArray2.push(temp)

                    return file
                })

                console.log(newArray2)
                setFormValues3([...newArray2]);
                setLoading(false)

            } else {
                console.log("Unexpected response structure:", response);
                setLoading(false)

            }
        } catch (error) {
            console.log("Error:", error);
        }
    };

    // useEffect(() => {
    //   onloadvalues()
    // })
    const [leaveLog, setleaveLog] = useState([]);

    // const { register, handleSubmit, reset, trigger, clearErrors, formState: { errors }, setValue, getValues } = useForm();


    const [domianname, setdomianname] = useState()

    console.log(domianname, "ss")

    useEffect(() => {


        var currentURL = window.location.hostname;
        var parts = currentURL.split('.')
        var subdomain = ''
        if (parts.length >= 3) {
            // The subdomain is the first part of the URL
            subdomain = parts[0];
            console.log("Subdomain:", subdomain);
        } else {
            console.log("No subdomain found.");
        }

        // getUsersdatefilter(1)
    }, [])




    const [startfromdate, setStartfromdate] = useState("");
    const [startenddate, setStartenddate] = useState("");
    const [errorFromBackend, setErrorFromBackend] = useState("");

    const haveValuesInserch = (data) => {
        if (data) {
            setSearchTrue(true);
        } else {
            setSearchTrue(false);
        }
    };

    const [SearchTrue, setSearchTrue] = useState(false);
    const [keysearch, setkeysearch] = useState('')
    const handleKeySearch = (e) => {
        const key = e.target.value;
        setkeysearch(key)
        setCurrentPage(1);
        getUsersdatefilter(1, perPage, status, key);
        setSearchTrue(!!key);
    };

    const handleStatusChange = (newStatus) => {
        setkeysearch('')
        setStatus(newStatus);
        setCurrentPage(1);
        getUsersdatefilter(1, perPage, newStatus);
        fetchTicketCounts();
    };

    const onSearchFilter = (data) => {
        getUsersdatefilter(1);
    };


    useEffect(() => {
        getUsersdatefilter(currentPage, rowsPerPage, status, keysearch);
    }, [page, rowsPerPage]);

    const handlePageChange = (event, newPage) => {
        // getUsersdatefilter(newPage, rowsPerPage);
        setPage(newPage);
        setCurrentPage(newPage+1)
    };

    const handlePerRowsChange = (event) => {
        const value = event.target.value === 'All' ? Count : parseInt(event.target.value, 10);
        setRowsPerPage(value);
        setPage(0);
    };
    useEffect(() => {

    }, [startfromdate, startenddate])


    const handleClose = () => {
        setShow(false);
        setshowCommentAndFile(false);
    };
    const [showCommentAndFile, setshowCommentAndFile] = useState(false)
    const addopentickets = () => {
        setshowCommentAndFile(true);
    };
    const createTicketcancel = () => {
        setshowCommentAndFile(false);
        setFormValues3([])
        setPoliciesfilesErrorMessage("")
    };



    let addFormFields3 = () => {
        setFormValues3([...formValues3, { attachment1: { 'name': "" }, attachment2: {}, is_deleted: false, id: null }])
        seterror1("")
    }
    const [fileError, setFileError] = useState('');
    const handleChange = (e) => {
        const files = Array.from(e.target.files);
        let error = '';
        let selectedFiles = [];
        if (files.length > 5) {
            error = 'You can upload a maximum of 5 files.';
        } else {
            files.forEach(file => {
                if (file.size > 2 * 1024 * 1024) { 
                    error = 'File size should be less than 2MB.';
                } else {
                    selectedFiles.push(file);
                }
            });
        }
        if (!error) {
            setDocuments((prevDocs) => [...prevDocs, ...selectedFiles]);
            const updatedFileNames = [...documents, ...selectedFiles].map(file => file.name).join(', ');
            setSelectedFileNames(updatedFileNames);
            setFileError('');
        } else {
            setFileError(error);
        }
    };


    const removeFile = (index) => {
        const updatedDocuments = documents.filter((_, i) => i !== index);
        setDocuments(updatedDocuments);
        const updatedFileNames = updatedDocuments.map(file => file.name).join(', ');
        setSelectedFileNames(updatedFileNames);
    };
    const validateFileSize = (value) => {
        if (!value) return true;
        const fileSize = value[0]?.size;
        const maxFileSize = 10 * 1024 * 1024;
        if (fileSize > maxFileSize) {
            return "File size exceeds the maximum allowed size (10 MB).";
        }
        return true;
    };

    let removeFormFields3 = (i) => {

        let newFormValues3 = [...formValues3];
        newFormValues3.map((item, id) => {
            if (id === i) {
                item.is_deleted = true;
            }
            return item
        });
        setFormValues3([...newFormValues3])
        seterror("")

    }
    const [nocallapi, setnocallapi] = useState(false)
    const onImageValue = (data) => {
        setError('certificateFile', { type: 'custom', message: "" });
        // setRemoveComanyFileValue(true)
        setHaveImage(false)
        setnocallapi(false)
        const updatedImageValue = data.target.files[0].name
        console.log(updatedImageValue, "aaaa")
        let file = data.target.files[0];
        let reader = new FileReader();
        reader.onload = function (e) {
            setFile(e.target.result);
        };
        reader.readAsDataURL(data.target.files[0]);

        if (file.size > 2e6) {
            // setImgErrorMsgPopUp(true)
            setTimeout(() => { setImgErrorMsgPopUp(false) }, 3000);
            setImgErrorMsgPopUpText("Please upload a file smaller than 2 MB")
            setValue('certificateFile', '')
            setPoliciesfilesErrorMessage('please upload a file')
            setnocallapi(true)
            return false;

        } else {

            if (data.target.files.length === 1) {
                var temp = data.target.files[0].type;

                if (temp == "application/pdf" || temp == "image/png" || temp == "image/jpeg") {

                } else {
                    setValue("certificateFile", "")
                    setPoliciesfilesErrorMessage('Please select valid file')
                    setImageName("")
                    setHaveImage(false)
                    setnocallapi(true)
                    return false

                }
                setPoliciesfilesErrorMessage('')
                setHaveImage(true)
                setImageName(updatedImageValue)

            } else {
                setPoliciesfilesErrorMessage('This field is required')
                setDisable(false)
                setHaveImage(false)

                setImageName("")
            }

        }

    }
    const [editorData, setEditorData] = useState("");
    const [successPopUp, setSuccessPopUp] = useState(false)



    const handleEditorDataChange = (content) => {
        setValue("ticket_desc", content);
        setEditorData(content);
    };
const [ProfileData, setProfileData] = useState([]);
    const GetData = async () => {
        try {
            const response = await axios.get('/apiV1/get-profile/');
            if (response.status === 200) {
                setProfileData(response.data.message);
            }
        } catch (error) {
        console.error("Error fetching profile data:", error.response ? error.response.data : error.message);
        }
    };
    useEffect(() => {
        GetData();
    }, []);
    const openticketsupdates = async () => {
        setLoader(true)
        var userinfo = JSON.parse(Cookies.get("user-info"));
        const formData = new FormData();
       // Utility to extract plain text from HTML content
        function stripHtml(html) {
            const tmp = document.createElement("div");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        }

        const plainText = stripHtml(editorData);

        if (plainText.trim() === "") {
            seterrmsgcommit("Please enter a comment");
            return false;
        }

        if (plainText.startsWith(" ")) {
            seterrmsgcommit("Comment should not start with a space");
            return false;
        }

        formData.append("sub_category_id", idsticketsub);
        formData.append("ticket_category_id", idsticketpri);
        formData.append("status", originalStatus); // Use original status
        formData.append("message", editorData);
        formData.append("user_email", ProfileData.email);
        formData.append("employee_number", userinfo.id);
        formData.append("company_name", ProfileData.company_name);
        formData.append("user_name", ProfileData.fullname);

        documents.forEach((file) => {
            formData.append(`files`, file);
        });

        // if (!editorData) {
        //     seterrmsgcommit("Please enter a comment");
        //     return false;
        // }

        try {
            // axios.defaults.headers.common = { 'Authorization': ` ` }
            const response = await axios.put(`${process.env.REACT_APP_API_URL2}/apiV1/ticket_update/${idsticketno}/update/`, formData,
                {
                    headers: {
                        Authorization: '',
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                setShow(false);
                setshowCommentAndFile(false);
                setSuccessPopUp(true);
                setLoader(false);
                setEditorData('');
                reset();
                await getUsersdatefilter(1, perPage, originalStatus);
                setDocuments([]);
                setSelectedFileNames('');
            }
        } catch (error) {
            setLoader(false);
            console.log("Error:", error);
        }
    };






    const paginationComponentOptions = {

        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    const handleDownload = (url, filename) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
    };

    const handleModalClose = () => setShowModal(false);

    const [ticketCounts, setTicketCounts] = useState({
        totalC: 0,
        openC: 0,
        closeC: 0,
        pendingC: 0,
    });

    const fetchTicketCounts = async (Page = rowsPerPage, current = currentPage,) => {
        var userinfo = JSON.parse(Cookies.get("user-info"));
        setLoader(false)
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/get_count_tickets/`, {
                page_number: current,
                page_size: Page,
                user_email: userinfo.email,
                company_name: userinfo.name,
                roles: userinfo.user_type,
                username: userinfo.username,
                id: userinfo.id
            },
                {
                    headers: {
                        Authorization: '',
                    }
                });

            const data = response.data.results;
            if (response.status === 200 || response.status === 201) {
                setLoader(true);
            }
            console.log(data);
            setTicketCounts({
                openC: data.open || 0,
                closeC: data.Closed || 0,
                pendingC: data.Pending || 0,
                totalC: data.total || 0,
            });

        } catch (error) {
            console.error('Error fetching ticket counts:', error);
            setLoader(true);
        }
    };
    useEffect(() => {
        fetchTicketCounts()
    }, [])
    const colors = ['#2e7d32', '#ed6c02', '#d32f2f'];
    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#fff',
            color: '#000',
            boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
            fontSize: 13,
            maxWidth: 300,
            whiteSpace: 'normal',
        },
    }));
    const ticketCards = [
        {
          label: "Total Tickets",
          valueKey: "totalC",
          status: "",
        },
        {
          label: "Open Tickets",
          valueKey: "openC",
          status: "open",
        },
        {
          label: "In Progress",
          valueKey: "pendingC",
          status: "pending",
        },
        {
          label: "Closed Tickets",
          valueKey: "closeC",
          status: "closed",
        }
      ];
      
    return (
        <>
         <PageContainer title="SmartInvestorDeck | Support">
            <ScheduleDemo showBanner={true} />
            {/* <Grid container spacing={3} textAlign="center">
                <Grid item xs={12} sm={6} lg={3} md={4}>
                    <Card
                        sx={{
                            maxHeight: 80,
                            minHeight: 50,
                            width: { xs: "100%", sm: "85%" },
                            borderRadius: 2,
                            p: 0,
                            boxShadow: 1,
                            "&:hover": { boxShadow: 4 },
                            overflow: "hidden",
                            mx: "auto",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#d0e3ff",
                            justifyContent: "space-between",
                        }}
                        onClick={() => handleStatusChange('')}
                    >
                        <CardContent sx={{ flexGrow: 1, justifyContent: "space-between", display: "flex" }}>
                            <Typography variant="h6" sx={{ color: "#000", textAlign: "center" }}>
                                Total Tickets
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 600, color: "#1976d2" }}>
                                {ticketCounts.totalC}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} lg={3} md={4}>
                    <Card
                        sx={{
                            maxHeight: 80,
                            minHeight: 50,
                            width: { xs: "100%", sm: "85%" },
                            borderRadius: 2,
                            p: 0,
                            boxShadow: 1,
                            "&:hover": { boxShadow: 4 },
                            overflow: "hidden",
                            mx: "auto",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "#e4fbd8",
                            justifyContent: "space-between",
                        }}
                        onClick={() => handleStatusChange('open')}
                    >
                        <CardContent sx={{ flexGrow: 1, justifyContent: "space-between", display: "flex" }}>
                            <Typography variant="h6" sx={{ color: "#000", textAlign: "center" }}>
                                Open Tickets
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 600, color: colors[0] }}>
                                {ticketCounts.openC}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} lg={3} md={4}>
                    <Card
                        sx={{
                            maxHeight: 80,
                            minHeight: 50,
                            width: { xs: "100%", sm: "85%" },
                            borderRadius: 2,
                            boxShadow: 1,
                            "&:hover": { boxShadow: 4 },
                            overflow: "hidden",
                            mx: "auto",
                            display: "flex",
                            backgroundColor: "#f3c9ad",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                        onClick={() => handleStatusChange('pending')}
                    >
                        <CardContent sx={{ flexGrow: 1, justifyContent: "space-between", display: "flex" }}>
                            <Typography variant="h6" sx={{ color: "#000" }}>
                                In Progress
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 600, color: colors[1] }}>
                                {ticketCounts.pendingC}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} lg={3} md={4}>
                    <Card
                        sx={{
                            maxHeight: 80,
                            minHeight: 50,
                            width: { xs: "100%", sm: "85%" },
                            borderRadius: 2,
                            boxShadow: 1,
                            backgroundColor: "#ffebea",
                            "&:hover": { boxShadow: 4 },
                            overflow: "hidden",
                            mx: "auto",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                        onClick={() => handleStatusChange('closed')}
                    >
                        <CardContent sx={{ flexGrow: 1, justifyContent: "space-between", display: "flex" }}>
                            <Typography variant="h6" sx={{ color: "#000" }}>
                                Closed Tickets
                            </Typography>
                            <Typography variant="h4" sx={{ fontWeight: 600, color: colors[2] }}>
                                {ticketCounts.closeC}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid> */}

            {/* card when it is clicked start */}

            <Grid container spacing={3} textAlign="center">
                {ticketCards.map(({ label, valueKey, status }) => (
                    <Grid item xs={12} sm={6} lg={3} md={4} key={status}>
                    <Card
                        sx={{
                        maxHeight: 80,
                        minHeight: 50,
                        width: { xs: "100%", sm: "85%" },
                        borderRadius: 2,
                        p: 0.4,
                        boxShadow: 0,
                        border: "1px solid #ededed",
                        cursor: "pointer",
                        overflow: "hidden",
                        mx: "auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: activeButton === status ? "#71a2c0" : "#fff",
                        color: activeButton === status ? "#fff" : "#000",
                        }}
                        onClick={() => {
                        handleStatusChange(status);
                        setActiveButton(status);
                        }}
                    >
                        <CardContent sx={{ flexGrow: 1, justifyContent: "space-between", display: "flex" }}>
                        <Typography variant="h6" className="card-title">
                            {label}
                        </Typography>
                        <Typography variant="h5" className="card-value">
                            {ticketCounts[valueKey]}
                        </Typography>
                        </CardContent>
                    </Card>
                    </Grid>
                ))}
                </Grid>


            {/* card when it is clicked start */}




            <Container maxWidth="1500px" >
                <Grid container spacing={3} sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                    <Grid item xs={12} sm={6} lg={2}>
                        <TextField
                            size="small"
                            label="Search"
                            value={keysearch}
                            onChange={handleKeySearch}
                            className="searchTextfieldClass"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={2}>
                        {/* {status === 'open' && ( */}
                        <Button
                            variant="contained"
                            fullWidth
                            className="button2"
                            onClick={() => {
                                navigate('/support/createticket');
                                // handleChange('createticket');
                            }}
                            sx={{ mb: 1 }}
                        >
                            <IconSquarePlus /> &nbsp; Create Ticket
                        </Button>
                        {/* )} */}
                    </Grid>

                </Grid>


                {loader ? <>
                    <TableContainer sx={{ overflow: 'auto', maxHeight: 540 }}>
                        <Table
                            stickyHeader aria-label="sticky table"
                            sx={{
                                whiteSpace: 'nowrap',
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }}>Ticket Number</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }}>Ticket Category</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }}>Ticket Sub Category</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }}>Ticket Description</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "18px" }}>Assigned To</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }}>Date</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }}>Status</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="h6" sx={{ fontSize: "1rem" }} className='ms-2'>Action</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tickets.map((ticket) => (
                                    <TableRow key={ticket.id} hover>
                                        <TableCell>{ticket.ticket_number}</TableCell>
                                        <TableCell>{ticket.ticket_category}</TableCell>
                                        <TableCell>{ticket.ticket_sub_category}</TableCell>
                                        <TableCell>
                                            <Box>
                                                <LightTooltip
                                                    title={<div dangerouslySetInnerHTML={{ __html: ticket.ticket_desc }} />}
                                                    arrow
                                                    placement="top"
                                                >
                                                    <Typography
                                                        // color="textSecondary"
                                                        sx={{
                                                            maxWidth: '200px',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            display: 'block',
                                                            cursor: 'pointer',
                                                            fontSize:"0.875rem"
                                                        }}
                                                        variant="subtitle2"
                                                        fontWeight="400"
                                                    >
                                                        {/* {ticket.ticket_desc.replace(/<[^>]+>/g, '')} */}
                                                        {ticket.ticket_desc.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')}
                                                        {/* <div dangerouslySetInnerHTML={{ __html: ticket.ticket_desc }} /> */}
                                                    </Typography>
                                                </LightTooltip>
                                            </Box>
                                        </TableCell>

                                        <TableCell>
                                            <Stack direction="row" gap="10px" alignItems="center">
                                                <Typography sx={{fontSize:"0.875rem"}}>{ticket.assigned_user}</Typography>
                                            </Stack>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>{moment(ticket.register_date).format("MM-DD-YYYY")}</Typography>
                                            <Typography>{moment(ticket.register_date).format("HH:mm:ss")}</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                sx={{
                                                    backgroundColor:
                                                        ticket.ticket_status_value === 'open'
                                                            ? (theme) => theme.palette.success.light
                                                            : ticket.ticket_status_value === 'Closed'
                                                                ? (theme) => theme.palette.error.light
                                                                : ticket.ticket_status_value === 'Inprogress' || ticket.ticket_status_value === 'Pending'
                                                                    ? (theme) => theme.palette.warning.light
                                                                    : ticket.ticket_status_value === 'Moderate',
                                                                    color:"#fff"
                                                }}
                                                size="small"
                                                label={ticket.ticket_status_value === 'Pending' ? 'In Progress' : ticket.ticket_status_value}
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <IconButton onClick={() => openTicketDetailsModal(ticket)}>
                                                <IconEdit color={"#182286"} />
                                            </IconButton>
                                            {/* <Tooltip title="Ticket Details"> */}
                                            <IconButton onClick={() => TicketDetailsModal(ticket)}>
                                                <IconEye color={"#182286"} />
                                            </IconButton>
                                            {/* </Tooltip> */}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {tickets.length === 0 && (<TableRow><TableCell colSpan={6} sx={{ textAlign: "center", fontSize: "14px" }}>There are no records to display</TableCell></TableRow>)}
                            </TableBody>

                        </Table>
                    </TableContainer>
                    <TablePagination
                        colSpan={6}
                        count={Count}
                        page={page}
                        component="div"
                        rowsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handlePerRowsChange}
                        rowsPerPageOptions={[10, 20, 50, { value: Count, label: 'All' }]}
                    /> </> : <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                                width: "100vw",
                                position: "fixed",
                                top: 0,
                                left: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                zIndex: 9999,
                                }}
                         >
                    <BeatLoader  color='#014670' size={20}/>
                  </div>}
            </Container>
            <Dialog maxWidth='lg' open={show}>
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                }}
                >
                    <Typography>Ticket Details </Typography>
                  <IconButton onClick={() => {setShow(false);seterrmsgcommit('');setFileError('')}}>
                    <IconX sx={{ fontSize: 30, ml: 1 }} />
                  </IconButton>
                </DialogTitle>
                {!loading ? <DialogContent>
                    <form className='AddNewDept_form' id='AddNewDept_form' name='AddNewDept_form' onSubmit={handleSubmit(openticketsupdates)}>
                        <div className="mb-4">
                            {/* <h6 className="card-title h4-card">Ticket Details</h6> */}
                        </div>
                        <div className="table-responsive" id='openticketstableview'>
                            <Table >
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 'bold' }}>Ticket Number</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Category</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Opened</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Last Updated</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Updated by </TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    <TableRow>
                                        <TableCell>{opendataticket.ticket_number}</TableCell>
                                        <TableCell>{opendataticket.ticket_category}</TableCell>
                                        <TableCell>{moment(opendataticket.register_date).format("MM-DD-YYYY")}</TableCell>
                                        <TableCell>{moment(opendataticket.updated_date).format("MM-DD-YYYY")}</TableCell>
                                        <TableCell>{opendataticket.updated_by_name} </TableCell>
                                        <TableCell>
                                            {opendataticket.ticket_status_value === 'Pending' ? 'In Progress' : opendataticket.ticket_status_value}
                                        </TableCell>

                                    </TableRow>
                                </TableBody>
                            </Table>
                            {/* <table className="table mb-0 table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Tickect Number</th>
                    <th>Category</th>
                    <th>Opened</th>
                    <th>Last Updated</th>
                    <th>Updated by</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{opendataticket.ticket_number}</td>
                    <td>{opendataticket.ticket_category}</td>
                    <td>{moment(opendataticket.register_date).format("DD-MM-YYYY")}</td>
                    <td>{moment(opendataticket.updated_date).format("DD-MM-YYYY")}</td>
                    <td>{opendataticket.updated_by}</td>
                    <td><span className="fw-semibold text-warning font-size-15">{opendataticket.ticket_status_value}</span></td>
                  </tr>
                </tbody>
              </table> */}
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <h4 className="mb-4 fw-semibold">Ticket Description</h4>
                                {selectedTicketDetails && (
                                    // <div dangerouslySetInnerHTML={{ __html: selectedTicketDetails.ticket_desc.replace(/<p>/g, '').replace(/<\/p>/g, '') }} />
                                    <div>
                                            <div dangerouslySetInnerHTML={{ __html: selectedTicketDetails.ticket_desc }} />
                                        </div>
                                )}
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <h4 className="mb-4">Ticket Documents</h4>
                                <div className='row'>
                                    {formValues3.map((element, index) => (
                                        !element.is_deleted && (
                                            <div className="form-inline col-md-3 text-center" key={index}>
                                                {/* <span className="text-primary btn text-center">
                          <AiOutlineCloudDownload className='text-success' style={{ fontSize: "30px" }} onClick={() => handleDownload(element?.attachment1?.new_presigned_url)} />
                        </span> */}
                                                <div className='text-center'>
                                                    {logoImagePathCon && (
                                                        <p className="mt-3" style={{ lineBreak: "anywhere" }}
                                                        //  onClick={() => handleDownload(element?.attachment1?.new_presigned_url)}
                                                         >
                                                            <span className="text-primary btn" style={{ color: "blue" }}>{element?.attachment1?.doc_name}</span>
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <Form.Group controlId="formDocument">
                                    <Form.Label className="col-sm-4 text-right" style={{ fontWeight: 'bold' }}>
                                        Comment
                                        <span className="text-danger" style={{color:"red"}}>*</span>
                                    </Form.Label>
                                    <Controller
                                        name="ticket_desc"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: "Comment is required" }}
                                        render={({ field }) => (
                                            <SunEditor
                                                placeholder="Please type here..."
                                                lang="en"
                                                setDefaultStyle="font-family: Arial; font-size: 14px;"
                                                setOptions={options}
                                                // onChange={(content) => {
                                                //     field.onChange(content);
                                                //     handleEditorDataChange(content);
                                                // }}
                                                // onKeyUp={() => seterrmsgcommit('')}
                                                setContents={field.value}
                                                onChange={(content) => {
                                                  const cleaned = content.replace(/<[^>]+>/g, '').trim();
                                                  field.onChange(cleaned ? content : ''); // Treat empty content as invalid
                                                  handleEditorDataChange(cleaned ? content : '');
                                                }}
                                                onKeyUp={() => seterrmsgcommit('')}
                                                onBlur={field.onBlur}
                                                value={field.value}
                                            />
                                        )}
                                    />
                                </Form.Group>
                                <small className='text-danger' style={{color:"red"}}>{errmsgcommit}</small>


                                <div className="text-start mb-3 mt-3">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <Typography className="form-label" style={{ fontWeight: 'bold',mt:1}}>
                                                Choose files
                                                {/* <span className="text-danger">*</span> */}
                                            </Typography>
                                            <TextField
                                                className="form-control mb-1"
                                                type="text"
                                                value={selectedFileNames || "No file chosen"}
                                                readOnly
                                                onClick={() => document.getElementById('formFile').click()}
                                                onDrop={(e) => {
                                                    e.preventDefault();
                                                    const droppedFiles = Array.from(e.dataTransfer.files);
                                                    handleChange({ target: { files: droppedFiles } });
                                                  }}
                                                  onDragOver={(e) => e.preventDefault()}
                                            />

                                            <input
                                                id="formFile"
                                                type="file"
                                                style={{ display: 'none' }}
                                                accept=".docx, .pdf, .jpg, .jpeg, .png, .csv, .txt, .xlsx, .mp4"
                                                multiple
                                                onChange={handleChange}
                                            />
                                            {fileError && <p className="text-danger font-bold" style={{color:"red"}}>{fileError}</p>}
                                            {documents.map((file, index) => (
                                                <p key={index} className="mt-2 text-primary" style={{color:"green"}}>{file.name}
                                                    <span className="text-danger ms-2" style={{ cursor: "pointer",color:"red" }} onClick={() => removeFile(index)}>
                                                        <IconXboxX style={{ fontSize: "1.2em", verticalAlign: "middle" }} />
                                                    </span>
                                                </p>
                                            ))}
                                            <p className="mt-2">
                                                <span style={{ fontWeight: 'bolder' }}>Accepted file types:</span>(.docx, .pdf, .jpg, .jpeg, .png, .csv, .txt, .xlsx, .mp4)
                                            </p>
                                        </div>
                                    </div>
                                    <small className='text-danger font-bold'>{PoliciesfilesErrorMessage}</small>
                                    <small className="text-danger">{error}</small>
                                    <small className="text-danger">{error1}</small>
                                    <div className="row">
                                        <div className="text-end">
                                            <Button variant="contained" type="button" color="warning" onClick={() => { setShow(false); reset(); seterrmsgcommit(''); setSelectedFileNames('');setDocuments([]);setFileError('');document.getElementById('formFile').value = null}}>Cancel</Button> &nbsp;
                                            <Button variant="contained" color="#fff" type='submit' className='button2'>{!loader ?  <BeatLoader color='#014670' size={20}/>:"Update"}</Button>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {commetscustmer.length !== 0 &&
                            <div className="mt-4">
                                <h4 className="card-title h4-card mb-3">Ticket Comments</h4>
                            </div>}
                        {commetscustmer.length !== 0 && (
                            <div id="TicketDetailsComments" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                {commetscustmer.map((item, i) => (
                                    <div key={i}>
                                        <div>
                                            <h6>{item.name} {item.cdate}</h6>
                                        </div>
                                        <div>
                                            <div dangerouslySetInnerHTML={{ __html: item.message }} />
                                        </div>
                                        <p style={{ border: "1px dashed", opacity: ".25" }}></p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </form>
                </DialogContent> : (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '300px',
                            width: '600px'
                        }}
                    >
                        <BeatLoader size={28} color='#014670' />
                    </Box>
                )}
            </Dialog>
            <Dialog maxWidth='lg' open={DetailShow} >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                }}
                >
                    <Typography variant='h6'>Ticket Details </Typography>
                   <IconButton onClick={() => setDetailShow(false)}><IconX sx={{ fontSize: 30, ml: 1 }} /></IconButton>
                </DialogTitle>
                <Divider />
                {!loading ? <DialogContent>
                    <div className="table-responsive" id='openticketstableview'>
                        <Table >
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold' }}>Ticket Number</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Category</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Opened</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Last Updated</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Updated by </TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{opendataticket.ticket_number}</TableCell>
                                    <TableCell>{opendataticket.ticket_category}</TableCell>
                                    <TableCell>{moment(opendataticket.register_date).format("MM-DD-YYYY")}</TableCell>
                                    <TableCell>{moment(opendataticket.updated_date).format("MM-DD-YYYY")}</TableCell>
                                    <TableCell>{opendataticket.updated_by_name} </TableCell>
                                    <TableCell>
                                        {opendataticket.ticket_status_value === 'Pending' ? 'In Progress' : opendataticket.ticket_status_value}
                                    </TableCell>

                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            <h4 className="mb-4 fw-semibold">Ticket Description</h4>
                            {selectedTicketDetails && (
                                // <div dangerouslySetInnerHTML={{ __html: selectedTicketDetails.ticket_desc.replace(/<p>/g, '').replace(/<\/p>/g, '') }} />
                                <div>
                                            <div dangerouslySetInnerHTML={{ __html: selectedTicketDetails.ticket_desc }} />
                                        </div>
                            )}
                        </div>
                    </div>
                    {formValues3?.length>=1&& <div className="row mt-4">
                        <div className="col-12">
                            <h4 className="mb-4 fw-semibold">Ticket Documents</h4>
                            <div className='row'>
                                {formValues3.map((element, index) => (
                                    !element.is_deleted && (
                                        <div className="form-inline col-md-3 text-center" key={index}>
                                            <div className='text-center'>
                                                {logoImagePathCon && (
                                                    <p
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px", // or use marginRight on the icon instead
                                                            lineBreak: "anywhere",
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => handleDownload(element?.attachment1?.new_presigned_url,element?.attachment1?.doc_name)}
                                                    >
                                                        <IconCloudDown color="#218b27" style={{ fontSize: 20 }} />
                                                        <span className="text-primary btn" style={{ color: "#014670" }}>
                                                            {element?.attachment1?.doc_name}
                                                        </span>
                                                    </p>

                                                )}
                                            </div>
                                        </div>
                                    )
                                ))}
                            </div>
                        </div>
                    </div>}
                    <div className="row">
                        {commetscustmer.length !== 0 &&
                            <div className="mt-4">
                                <h4 className="card-title h4-card mb-3">Ticket Comments</h4>
                            </div>}
                        {commetscustmer.length !== 0 && (
                            <div id="TicketDetailsComments" style={{ maxHeight: "300px", overflowY: "auto" }}>
                                {commetscustmer.map((item, i) => (
                                    <div key={i}>
                                        <div>
                                            <h6>{item.updated_by} {item.cdate}</h6>
                                        </div>
                                        <div>
                                            <div dangerouslySetInnerHTML={{ __html: item.message }} />
                                        </div>
                                        <p style={{ border: "1px dashed", opacity: ".25" }}></p>
                                    </div>
                                ))}
                            </div>
                        )}
                        <div className="col-12">
                            <div className="row">
                                <div className="text-end">
                                    <Button variant="contained" type="button" color="warning" sx={{mt:2}}onClick={() => { setDetailShow(false); reset(); }}>Close</Button> &nbsp;
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent> : <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '300px',
                        width: '600px'
                    }}
                >
                    <BeatLoader size={28} color='#014670' />
                </Box>}
            </Dialog>
            <Dialog open={successPopUp} fullWidth>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Success
                </DialogTitle>
                <Divider />

                <DialogContent sx={{ textAlign: "center" }}>
                    <Box sx={{ textAlign: "center", mb: 2 }}>
                        <IconButton sx={{ backgroundColor: "#c6f1d1", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
                            <IconCheck color="#198b08" size={50} />
                        </IconButton>
                    </Box>
                    Saved Successfully!
                </DialogContent>
                <Divider />
                <DialogActions sx={{ justifyContent: "flex-end" }}>
                    <Button onClick={() => setSuccessPopUp(false)} color="success" variant="contained">
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>

            </PageContainer>

        </>
    );
};

export default Support;
